export const PAYSLIP_PERMISSION_CODES = {
    WEB_PAYROLL_PAYSLIP_LIST: 'WEB_PAYROLL_PAYSLIP_LIST',
    WEB_PAYROLL_PAYSLIP_DETAIL: 'WEB_PAYROLL_PAYSLIP_DETAIL',
    WEB_PAYROLL_PAYSLIP_CALCULATE: 'WEB_PAYROLL_PAYSLIP_CALCULATE',
    WEB_PAYROLL_PAYSLIP_EXPORT: 'WEB_PAYROLL_PAYSLIP_EXPORT',
} as const;


